import React, { Component } from 'react'
import s from './style.scss'
import classnames from 'classnames'

class Modal extends Component {

	constructor(props) {
		super(props)

		this.state = {
			hide: false
		}
	}

	render() {

		const { children, hide, title, close, large } = this.props

		if (hide) return null

		return <div className={classnames(s.container)}>
			<div className={classnames(s.content, large && s.large)}>
				<header className={s.header}>
					{title && <b>{title}</b>}
					<div className={s.close}>
						<i className="fas fa-times" onClick={close}></i>
					</div>
				</header>
				<div className={s.main}>
					{children}
				</div>
			</div>
		</div>
	}
}

export default Modal


// WEBPACK FOOTER //
// ./src/components/Modal/index.js